export default "https://cdn-static.gokick.com/assets/ac567471f1b9fb2f6cedfba22f3391469dbaa38e/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";